import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Import your images
import kabiniLogo from '../assets/images/kabini logo.jpg';
import patternImg from '../assets/images/pattern1.png';

const AboutPage = () => {
  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 800,
      once: true,
      mirror: false,
      offset: 40,
      easing: 'ease-out-quad'
    });

    // Preloader hide after page load
    const preloader = document.querySelector('.preloader');
    if (preloader) {
      setTimeout(() => {
        preloader.style.opacity = '0';
        preloader.style.visibility = 'hidden';
      }, 500);
    }

    // Cleanup function
    return () => {
      // Cleanup if needed
    };
  }, []);

  // Social Icons SVG Sprites
  const socialIcons = (
    <svg style={{ display: 'none' }}>
      <symbol id="facebook" viewBox="0 0 24 24">
        <path d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z"/>
      </symbol>
      <symbol id="twitter" viewBox="0 0 24 24">
        <path d="M23.953 4.57a10 10 0 0 1-2.825.775 4.958 4.958 0 0 0 2.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 0 0-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 0 0-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 0 1-2.228-.616v.06a4.923 4.923 0 0 0 3.946 4.827 4.996 4.996 0 0 1-2.212.085 4.937 4.937 0 0 0 4.604 3.417 9.868 9.868 0 0 1-6.102 2.104c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 0 0 7.557 2.209c9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63a9.936 9.936 0 0 0 2.46-2.548l-.047-.02z"/>
      </symbol>
      <symbol id="linkedin" viewBox="0 0 24 24">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451c.979 0 1.771-.773 1.771-1.729V1.729C24 .774 23.204 0 22.225 0z"/>
      </symbol>
      <symbol id="instagram" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4.965-10.405a1.44 1.44 0 1 1 2.881.001 1.44 1.44 0 0 1-2.881-.001z"/>
      </symbol>
      <symbol id="youtube" viewBox="0 0 24 24">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </symbol>
    </svg>
  );

  // Team members data
  const teamMembers = [
    {
      name: 'John Smith',
      role: 'Founder & CEO',
      description: 'Third-generation farmer with a passion for sustainable agriculture.',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80'
    },
    {
      name: 'Sarah Johnson',
      role: 'Farm Relations Director',
      description: 'Works directly with our 200+ farm partners to ensure quality and sustainability.',
      image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80'
    },
    {
      name: 'Michael Chen',
      role: 'Operations Manager',
      description: 'Ensures your produce is harvested, packed, and delivered within 24 hours.',
      image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80'
    },
    {
      name: 'Emily Rodriguez',
      role: 'Customer Experience Lead',
      description: 'Dedicated to making sure every customer has a fresh and happy experience.',
      image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80'
    }
  ];

  // Testimonials data
  const testimonials = [
    {
      name: 'Jennifer L.',
      since: '2021',
      text: 'The freshest vegetables I\'ve ever had! You can really taste the difference with organic produce delivered straight from the farm.',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=50&q=80',
      rating: 5
    },
    {
      name: 'Robert M.',
      since: '2019',
      text: 'I love knowing exactly where my food comes from. The delivery is always on time and the produce lasts so much longer than store-bought.',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=50&q=80',
      rating: 5
    },
    {
      name: 'Lisa T.',
      since: '2022',
      text: 'The variety is amazing! Every week I discover new seasonal fruits and vegetables. My kids actually get excited about eating healthy now!',
      image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=50&q=80',
      rating: 5
    }
  ];

  // Timeline data
  const timelineEvents = [
    { year: '2010', title: 'The Beginning', description: 'Started as a small family farm stand at the local farmers market with just 5 varieties of organic vegetables.' },
    { year: '2013', title: 'First Farm Partnership', description: 'Partnered with 3 local farms to expand our offerings and bring more variety to our customers.' },
    { year: '2015', title: 'Launched Home Delivery', description: 'Introduced our farm-to-doorstep delivery service, starting with 50 customers in our local area.' },
    { year: '2018', title: 'Organic Certification', description: 'Received official organic certification for all our partner farms, ensuring 100% organic produce.' },
    { year: '2020', title: 'Reached 200 Farm Partners', description: 'Expanded our network to include over 200 local farmers, offering more than 50 varieties.' },
    { year: '2023', title: '15,000 Happy Customers', description: 'Celebrated serving over 15,000 families with fresh, organic produce delivered right to their doors.' }
  ];

  // Values data
  const values = [
    { icon: 'leaf', title: 'Sustainability', description: 'We practice and promote farming methods that protect our soil, water, and environment for future generations.' },
    { icon: 'heart', title: 'Community', description: 'We build strong relationships with local farmers and customers, creating a community centered around healthy food.' },
    { icon: 'hand-holding-heart', title: 'Integrity', description: 'We\'re transparent about our sourcing and farming practices – you can trust where your food comes from.' },
    { icon: 'star', title: 'Quality', description: 'We never compromise on freshness and flavor, delivering only the finest organic produce to your doorstep.' }
  ];

  // Add all the CSS styles
  const styles = `
    :root {
      --fresh-green: #4CAF50;
      --fresh-green-dark: #388E3C;
      --fresh-orange: #FF9800;
      --fresh-yellow: #FFC107;
      --bg-light: #F8F9FA;
    }

    /* Preloader Styles */
    .preloader {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #fff;
      z-index: 9999;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: opacity 0.5s ease, visibility 0.5s ease;
    }

    .loader {
      width: 48px;
      height: 48px;
      border: 5px solid var(--fresh-green);
      border-bottom-color: transparent;
      border-radius: 50%;
      display: inline-block;
      box-sizing: border-box;
      animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    /* Page Header */
    #page-header {
      min-height: 400px;
      display: flex;
      align-items: center;
    }

    /* Timeline Styles */
    .timeline-item {
      position: relative;
      padding-left: 30px;
      margin-bottom: 30px;
      border-left: 3px solid var(--fresh-green);
    }
    
    .timeline-item::before {
      content: '';
      position: absolute;
      left: -9px;
      top: 0;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background: var(--fresh-green);
    }

    .timeline-item h4 {
      color: var(--fresh-green-dark);
      font-weight: bold;
    }

    /* Value Card Styles */
    .value-card {
      text-align: center;
      padding: 30px 20px;
      border-radius: 15px;
      background: white;
      box-shadow: 0 5px 20px rgba(0,0,0,0.05);
      transition: all 0.3s ease;
      height: 100%;
    }
    
    .value-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 30px rgba(0,0,0,0.1);
    }
    
    .value-icon {
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
      background: var(--fresh-green);
      color: white;
      border-radius: 50%;
      font-size: 2rem;
      margin: 0 auto 20px;
      transition: all 0.3s ease;
    }

    .value-card:hover .value-icon {
      transform: scale(1.1);
      background: var(--fresh-green-dark);
    }

    /* Team Card Styles */
    .team-card {
      transition: all 0.3s ease;
      border: 1px solid #eee;
      border-radius: 15px;
      overflow: hidden;
      background: white;
      height: 100%;
    }
    
    .team-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 30px rgba(0,0,0,0.1);
    }

    .team-card .social-links a {
      transition: all 0.3s ease;
      display: inline-block;
    }

    .team-card .social-links a:hover {
      color: var(--fresh-green) !important;
      transform: translateY(-3px);
    }

    /* Testimonial Card Styles */
    .testimonial-card {
      background: white;
      padding: 2rem;
      border-radius: 15px;
      height: 100%;
      transition: all 0.3s ease;
      border: 1px solid #eee;
    }

    .testimonial-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 30px rgba(0,0,0,0.1);
    }

    /* Button Styles */
    .btn-primary {
      background-color: var(--fresh-green) !important;
      border-color: var(--fresh-green) !important;
    }
    
    .btn-primary:hover {
      background-color: var(--fresh-green-dark) !important;
      border-color: var(--fresh-green-dark) !important;
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(76, 175, 80, 0.3);
    }

    .btn-arrow i {
      transition: transform 0.3s ease;
    }

    .btn-arrow:hover i {
      transform: translateX(5px);
    }

    /* Social Icons */
    .social-links .social {
      transition: transform 0.3s ease;
    }

    .social-links .social:hover {
      transform: translateY(-3px);
    }

    .social-links svg {
      fill: #666;
      transition: fill 0.3s ease;
    }

    .social-links .social:hover svg {
      fill: var(--fresh-green);
    }

    /* Navbar Styles */
    #primary-header {
      background: white;
      box-shadow: 0 2px 10px rgba(0,0,0,0.05);
    }

    .navbar-nav .nav-link {
      position: relative;
      padding: 5px 0 !important;
    }

    .navbar-nav .nav-link::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 0;
      height: 2px;
      background: var(--fresh-green);
      transition: width 0.3s ease;
    }

    .navbar-nav .nav-link:hover::after,
    .navbar-nav .nav-link.active::after {
      width: 100%;
    }

    /* Dropdown Menu Animation */
    .dropdown-menu {
      display: block;
      opacity: 0;
      visibility: hidden;
      transform: translateY(10px);
      transition: all 0.3s ease;
    }

    .dropdown:hover .dropdown-menu {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }

    .dropdown-item {
      transition: all 0.3s ease;
    }

    .dropdown-item:hover {
      background: var(--fresh-green);
      color: white !important;
      padding-left: 20px;
    }

    /* Logo Animation */
    .logo {
      transition: transform 0.3s ease;
    }

    .logo:hover {
      transform: scale(1.05);
    }

    /* Responsive Styles */
    @media (max-width: 768px) {
      .padding-side {
        padding-left: 1rem;
        padding-right: 1rem;
      }
      
      .display-1 {
        font-size: 3rem;
      }
      
      .display-2 {
        font-size: 2.5rem;
      }
      
      .display-3 {
        font-size: 2rem;
      }
    }

    /* Utility Classes */
    .padding-side {
      padding-left: 3rem;
      padding-right: 3rem;
    }

    .padding-large {
      padding: 5rem 0;
    }

    .padding-medium {
      padding: 4rem 0;
    }

    .bg-light {
      background-color: #f8f9fa !important;
    }

    .text-primary {
      color: var(--fresh-green) !important;
    }

    .grayscale {
      filter: grayscale(100%);
      transition: filter 0.3s ease;
    }

    .grayscale:hover {
      filter: grayscale(0%);
    }

    .opacity-75 {
      opacity: 0.75;
    }

    .opacity-75:hover {
      opacity: 1;
    }
  `;

  return (
    <div className="about-page">
      {/* Inject Styles */}
      <style>{styles}</style>

      {/* SVG Sprites */}
      {socialIcons}

      {/* Preloader */}
      <div className="preloader">
        <div className="loader"></div>
      </div>

      {/* Header */}
      <header id="header">
        <nav className="header-top py-1" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #eee' }}>
          <div className="container-fluid padding-side">
            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <ul className="info d-flex flex-wrap list-unstyled m-0">
                <li className="location text-capitalize d-flex align-items-center me-4" style={{ fontSize: '14px', color: '#666' }}>
                  <i className="fa fa-map-marker-alt" style={{ color: '#388E3C', marginRight: '5px' }}></i> HD Kote Taluk, Karapura, Around Mysore - 571 114
                </li>
                <li className="phone d-flex align-items-center me-4" style={{ fontSize: '14px', color: '#666' }}>
                  <i className="fa fa-phone" style={{ color: '#388E3C', marginRight: '5px' }}></i>9886228154
                </li>
                <li className="time d-flex align-items-center me-4" style={{ fontSize: '14px', color: '#666' }}>
                  <i className="fa fa-envelope" style={{ color: '#388E3C', marginRight: '5px' }}></i>Info@kabinee.com
                </li>
              </ul>
              <ul className="social-links d-flex flex-wrap list-unstyled m-0">
                <li className="social">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#facebook"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#twitter"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#linkedin"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#instagram"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#youtube"></use>
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <nav id="primary-header" className="navbar navbar-expand-lg py-4">
          <div className="container-fluid padding-side">
            <div className="d-flex justify-content-between align-items-center w-100">
              <Link className="navbar-brand" to="/">
                <img src={kabiniLogo} className="logo img-fluid" style={{ width: '18%' }} alt="Kabini Logo" />
              </Link>

              {/* Navbar Toggler Button */}
              <button className="navbar-toggler border-0 d-flex d-lg-none order-3 p-2 shadow-none" type="button"
                data-bs-toggle="offcanvas" data-bs-target="#bdNavbar" 
                aria-controls="bdNavbar" aria-expanded="false">
                <svg className="navbar-icon" width="40" height="40" style={{ color: '#000000', fill: 'currentColor' }}>
                  <rect x="10" y="12" width="20" height="2" fill="currentColor"/>
                  <rect x="10" y="22" width="20" height="2" fill="currentColor"/>
                  <rect x="10" y="32" width="20" height="2" fill="currentColor"/>
                </svg>
              </button>

              <div className="header-bottom offcanvas offcanvas-end" id="bdNavbar" aria-labelledby="bdNavbarOffcanvasLabel">
                <div className="offcanvas-header px-4 pb-0">
                  <h5 className="offcanvas-title" id="bdNavbarOffcanvasLabel">Menu</h5>
                  <button type="button" className="btn-close btn-close-black" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className="offcanvas-body align-items-center justify-content-center">
                  <div className="search d-block d-lg-none m-4"></div>
                  <ul className="navbar-nav align-items-center mb-2 mb-lg-0">
                    <li className="nav-item px-3">
                      <Link className="nav-link p-0 fw-bold" to="/agroindex">Home</Link>
                    </li>
                    <li className="nav-item px-3">
                      <Link className="nav-link active p-0 fw-bold" to="/about">About</Link>
                    </li>
                    <li className="nav-item px-3 dropdown">
                      <Link className="nav-link p-0 dropdown-toggle fw-bold" data-bs-toggle="dropdown" to="#" role="button" aria-expanded="false">Products</Link>
                      <ul className="dropdown-menu dropdown-menu-end animate slide mt-3 border-0 shadow">
                        {/* <li><Link to="/fruits" className="dropdown-item fw-bold">Fruits</Link></li> */}
                        <li><Link to="/vegetables" className="dropdown-item fw-bold">Vegetables</Link></li>
                        <li><Link to="/spices" className="dropdown-item fw-bold">Spices</Link></li>
                      </ul>
                    </li>
                    <li className="nav-item px-3">
                      <Link className="nav-link p-0 fw-bold" to="/contact">Contact</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>

      {/* Page Header */}
      <section id="page-header" className="padding-large" style={{
        background: "linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url('https://images.unsplash.com/photo-1464226184884-fa280b87c399?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '400px',
        display: 'flex',
        alignItems: 'center'
      }}>
        <div className="container-fluid padding-side text-center text-white">
          <h1 className="display-1 fw-normal" style={{ color: 'white' }}>About Fresh Harvest</h1>
        </div>
      </section>

      {/* Our Story Section */}
      <section id="our-story" className="padding-large">
        <div className="container-fluid padding-side" data-aos="fade-up">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h3 className="display-3 fw-normal">Our Story</h3>
              <h4 className="h2 fw-light mb-4">From a small family farm to your table</h4>
              <p className="lead">FreshHarvest began in 2010 with a simple vision: to provide families with the freshest, most nutritious organic produce while supporting local farmers and sustainable agriculture.</p>
              <p>What started as a small weekend farmers market stall has grown into a trusted community of over 200 local farmers, delivering farm-fresh vegetables and fruits to thousands of happy customers across the region.</p>
              <p>We believe that everyone deserves access to healthy, chemical-free food. That's why we work directly with farmers who share our passion for organic farming and sustainable practices. Every vegetable and fruit you receive is harvested at peak ripeness and delivered within 24 hours, ensuring maximum flavor and nutrition.</p>
              
              <div className="row mt-5">
                <div className="col-6">
                  <div className="d-flex align-items-center">
                    <i className="fas fa-check-circle fa-2x" style={{ color: 'var(--fresh-green)' }}></i>
                    <span className="ms-3 fw-bold">100% Organic Certified</span>
                  </div>
                </div>
                <div className="col-6">
                  <div className="d-flex align-items-center">
                    <i className="fas fa-check-circle fa-2x" style={{ color: 'var(--fresh-green)' }}></i>
                    <span className="ms-3 fw-bold">200+ Local Farm Partners</span>
                  </div>
                </div>
                <div className="col-6 mt-3">
                  <div className="d-flex align-items-center">
                    <i className="fas fa-check-circle fa-2x" style={{ color: 'var(--fresh-green)' }}></i>
                    <span className="ms-3 fw-bold">24hr Harvest to Delivery</span>
                  </div>
                </div>
                <div className="col-6 mt-3">
                  <div className="d-flex align-items-center">
                    <i className="fas fa-check-circle fa-2x" style={{ color: 'var(--fresh-green)' }}></i>
                    <span className="ms-3 fw-bold">15,000+ Happy Customers</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0">
              <div className="position-relative">
                <img src="https://images.unsplash.com/photo-1523741543316-beb7fc7023d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Our Farm" className="img-fluid rounded-4" />
                <div className="position-absolute bottom-0 start-0 bg-white p-4 rounded-4 m-4" style={{ maxWidth: '250px' }}>
                  <h3 className="display-4 fw-bold text-primary">2010</h3>
                  <p className="mb-0">Year Founded</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Mission & Vision */}
      <section id="mission-vision" className="padding-medium bg-light">
        <div className="container-fluid padding-side" data-aos="fade-up">
          <div className="row">
            <div className="col-md-6 mb-4 mb-md-0">
              <div className="bg-white p-5 rounded-4 h-100">
                <div className="value-icon">
                  <i className="fas fa-bullseye"></i>
                </div>
                <h3 className="display-5 fw-normal">Our Mission</h3>
                <p className="lead">To make healthy, organic food accessible to everyone while supporting sustainable farming practices and building a stronger community connection to local agriculture.</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="bg-white p-5 rounded-4 h-100">
                <div className="value-icon">
                  <i className="fas fa-eye"></i>
                </div>
                <h3 className="display-5 fw-normal">Our Vision</h3>
                <p className="lead">To create a world where fresh, organic produce is the norm, not the exception – where every meal is made with ingredients that are good for you and good for the planet.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section id="values" className="padding-medium">
        <div className="container-fluid padding-side" data-aos="fade-up">
          <div className="text-center mb-5">
            <h3 className="display-3 fw-normal">Our Core Values</h3>
            <p className="lead col-lg-6 mx-auto">The principles that guide everything we do, from farm to fork</p>
          </div>
          
          <div className="row">
            {values.map((value, index) => (
              <div key={index} className="col-md-6 col-lg-3 mb-4">
                <div className="value-card">
                  <div className="value-icon">
                    <i className={`fas fa-${value.icon}`}></i>
                  </div>
                  <h4 className="h4 fw-bold">{value.title}</h4>
                  <p className="mb-0">{value.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Journey Timeline */}
      <section id="timeline" className="padding-medium bg-light">
        <div className="container-fluid padding-side" data-aos="fade-up">
          <div className="text-center mb-5">
            <h3 className="display-3 fw-normal">Our Journey</h3>
            <p className="lead col-lg-6 mx-auto">Milestones that shaped FreshHarvest into what it is today</p>
          </div>
          
          <div className="row justify-content-center">
            <div className="col-lg-8">
              {timelineEvents.map((event, index) => (
                <div key={index} className="timeline-item">
                  <h4>{event.year} - {event.title}</h4>
                  <p>{event.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Meet Our Team */}
      <section id="team" className="padding-medium">
        <div className="container-fluid padding-side" data-aos="fade-up">
          <div className="text-center mb-5">
            <h3 className="display-3 fw-normal">Meet Our Team</h3>
            <p className="lead col-lg-6 mx-auto">The passionate people behind FreshHarvest</p>
          </div>
          
          <div className="row">
            {teamMembers.map((member, index) => (
              <div key={index} className="col-md-6 col-lg-3 mb-4">
                <div className="team-card">
                  <img src={member.image} alt={member.name} className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
                  <div className="p-4">
                    <h4 className="h4 fw-bold">{member.name}</h4>
                    <p className="text-primary mb-2">{member.role}</p>
                    <p className="small">{member.description}</p>
                    <div className="social-links mt-3">
                      <a href="#" className="text-dark me-3"><i className="fab fa-linkedin-in"></i></a>
                      <a href="#" className="text-dark me-3"><i className="fab fa-twitter"></i></a>
                      <a href="#" className="text-dark"><i className="far fa-envelope"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section id="testimonials" className="padding-medium bg-light">
        <div className="container-fluid padding-side" data-aos="fade-up">
          <div className="text-center mb-5">
            <h3 className="display-3 fw-normal">What Our Customers Say</h3>
            <p className="lead col-lg-6 mx-auto">Join 15,000+ happy families enjoying fresh organic produce</p>
          </div>
          
          <div className="row">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="col-md-4 mb-4">
                <div className="testimonial-card">
                  <div className="mb-3">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="fas fa-star text-warning"></i>
                    ))}
                  </div>
                  <p className="fst-italic">"{testimonial.text}"</p>
                  <div className="d-flex align-items-center mt-3">
                    <img src={testimonial.image} alt={testimonial.name} className="rounded-circle" style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
                    <div className="ms-3">
                      <h5 className="mb-0">{testimonial.name}</h5>
                      <small className="text-muted">Customer since {testimonial.since}</small>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section id="cta" className="padding-medium" style={{
        background: "linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url('https://images.unsplash.com/photo-1542838132-92c53300491e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}>
        <div className="container-fluid padding-side text-center text-white" data-aos="fade-up">
          <h3 className="display-2 fw-normal mb-4" style={{ color: 'white' }}>Ready to Taste the FreshHarvest Difference?</h3>
          <p className="lead col-lg-6 mx-auto mb-5" style={{ color: 'white' }}>Join thousands of happy families enjoying farm-fresh organic produce delivered to their door</p>
          <Link to="/vegetables" className="btn btn-arrow btn-primary btn-lg px-5 py-3">
            <span style={{ color: 'white' }}>Shop Now <i className="fas fa-arrow-right ms-2"></i></span>
          </Link>
        </div>
      </section>
      <br />

      {/* Footer */}
      {/* <section id="footer">
        <hr className="text-black" />
        <div className="container-fluid padding-side padding-small" data-aos="fade-up">
          <footer className="row">
            <div className="col-md-6 col-lg-3 mb-4 mb-lg-0">
              <h4 className="display-6 fw-normal">Quick links</h4>
              <ul className="nav flex-column">
                <li className="nav-item mb-2"><Link to="/" className="p-0 text-dark">Home</Link></li>
                <li className="nav-item mb-2"><Link to="/about" className="p-0 text-dark">About Us</Link></li>
                <li className="nav-item mb-2"><Link to="/vegetables" className="p-0 text-dark">Vegetables</Link></li>
                <li className="nav-item mb-2"><Link to="/spices" className="p-0 text-dark">Spices</Link></li>
                <li className="nav-item mb-2"><Link to="/contact" className="p-0 text-dark">Contact Us</Link></li>
              </ul>
            </div>
            <div className="col-md-6 col-lg-3 offset-lg-1 mb-4 mb-lg-0"></div>
            <div className="col-md-6 col-lg-3 offset-lg-1 mb-4 mb-lg-0">
              <p className="m-0">© Copyright 2024 FreshHarvest.</p>
              <p>Farm Fresh Organic Vegetables & Fruits<br /> Delivered with love from our family to yours</p>
            </div>
          </footer>
        </div>
      </section> */}
    </div>
  );
};

export default AboutPage;